import baseAPI from "@/http";

const router = "api/geral/acesso";

export const acessoAPI = {
  create: acesso => baseAPI.post(router, acesso),
  quantidadeAcessos: () => baseAPI.get(`${router}/quantidade-acessos`)
};
